import React from 'react'
import {connect} from 'react-redux'

import {
  VIEWPORT_TYPES,
  CHAT_STATUS
} from '../shared/config/constants'

import ChatUIPhone from './chat_ui.phone'
import ChatUIDesktop from './chat_ui.desktop'

class ChatUI extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      toggled: false
    }
  }

  userIdleTimeout () {
    let timeout = 3 * 60 * 1000 // 3 minutes

    if (this.props.chatSettings.idleStartMinutes) {
      timeout = parseInt(this.props.chatSettings.idleStartMinutes, 10) * 60 * 1000
    }

    return timeout
  }

  renderUI () {
    if (this.props.viewportType === VIEWPORT_TYPES.DESKTOP) {
      return (
        <ChatUIDesktop {...this.props} />
      )
    }
    else if (this.props.viewportType === VIEWPORT_TYPES.PHONE) {
      return (
        <ChatUIPhone  {...this.props} />
      )
    }
    else {
      return false
    }
  }

  render () {
    if (this.props.chatSettings.chatStatus === CHAT_STATUS.ON) {
      return this.renderUI()
    }
    else {
      return false
    }
  }
}

ChatUI.defaultProps = {
  chatSettings: {}
}

const mapStateToProps = (state) => {
  const chatSettings = state.getIn(['chatSettings'])
      , currentUser = state.getIn(['currentUser'])
      , currentGuest = state.getIn(['currentGuest'])

  return {
    viewportType: state.getIn(['viewport', 'type']),
    chatSettings: chatSettings.toObject(),
    currentUser: currentUser ? currentUser.toObject() : null,
    currentGuest: currentGuest ? currentGuest.toObject() : null
  }
}

const mapDispatchToProps = () => {
  return {}
}

const ChatUIContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatUI)

export default ChatUIContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_ui.js
 **/